export const localStorageRoutesPrefix = 'openmrs-routes:';
